import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {
  transform(array: any[], property: string, direction: 'asc' | 'desc' = 'asc', type: 'string' | 'number' | 'date' = 'string'): any[] {
    if (!Array.isArray(array) || !property) return array;

    return [...array].sort((a, b) => {
      let valueA = a[property];
      let valueB = b[property];

      try {
        // Parse values based on type
        if (type === 'number') {
          const numA = Number(valueA);
          const numB = Number(valueB);
          valueA = !isNaN(numA) ? numA : valueA;
          valueB = !isNaN(numB) ? numB : valueB;
        } else if (type === 'date') {
          const dateA = new Date(valueA);
          const dateB = new Date(valueB);
          valueA = !isNaN(dateA.getTime()) ? dateA : valueA;
          valueB = !isNaN(dateB.getTime()) ? dateB : valueB;
        }
        // else type === 'string', use values as-is
      } catch (e) {
        // Fallback to original values if parsing fails
        valueA = a[property];
        valueB = b[property];
      }

      // Compare values
      const comparison = valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      return direction === 'asc' ? comparison : -comparison;
    });
  }
}
